// extracted by mini-css-extract-plugin
export var alternate = "_1c-h";
export var black = "_1c-3";
export var blue = "_1c-d";
export var blueLight = "_1c-c";
export var brand = "_1c-7";
export var error = "_1c-9";
export var gray = "_1c-6";
export var grayBlue = "_1c-b";
export var iconWrapper = "_1c-4";
export var indigo = "_1c-e";
export var orange = "_1c-g";
export var pink = "_1c-f";
export var primary = "_1c-0";
export var purple = "_1c-8";
export var success = "_1c-5";
export var warning = "_1c-a";
export var white = "_1c-1";
export var whiteSuccess = "_1c-2";